import { render, staticRenderFns } from "./VItemsAddRemove.vue?vue&type=template&id=3fb1f33c"
import script from "./VItemsAddRemove.vue?vue&type=script&lang=js"
export * from "./VItemsAddRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports